uniform sampler2D tDiffuse;
uniform vec2 mousePos;
uniform float hovered;
uniform float time;
uniform float transitionProgress;
uniform float scrollOffset;
uniform vec2 resolution;
uniform float distortionAmount;
uniform float distortionFrequency;
uniform float waveAmplitude;
uniform float waveFrequency;
varying vec2 vUv;

float createRoundedMask(vec2 uv, vec2 dimensions, float cornerRadius) {
    vec2 aspectRatio = dimensions.x > dimensions.y 
        ? vec2(1.0, dimensions.y/dimensions.x) 
        : vec2(dimensions.x/dimensions.y, 1.0);
    
    vec2 normalizedCoords = (uv - 0.5) * 2.0 * aspectRatio;
    vec2 distanceToEdge = abs(normalizedCoords) - aspectRatio + cornerRadius;
    
    return length(max(distanceToEdge, 0.0)) + min(max(distanceToEdge.x, distanceToEdge.y), 0.0) - cornerRadius;
}

void main() {
    vec2 uv = vUv;
    
    // Effet de distorsion au survol
    if (hovered > 0.0) {
        vec2 mouseOffset = mousePos - uv;
        float dist = length(mouseOffset);
        float strength = 0.15 * (1.0 - dist);
        uv += mouseOffset * strength;
    }
    
    vec4 sourceColor = texture2D(tDiffuse, uv);

    // Création du masque avec coins arrondis
    float cornerRadius = 0.0;
    float roundedMask = createRoundedMask(vUv, resolution, cornerRadius);
    float maskAlpha = 1.0 - step(-0.0001, roundedMask);
    
    gl_FragColor = vec4(sourceColor.rgb, maskAlpha * sourceColor.a);
} 